import {
    NgModule,
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
// import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { createTranslateLoader } from './shared/utils/translate-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
    provideHttpClient,
    withInterceptorsFromDi,
    HttpClient
} from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AncToastComponent, AncViewportNoticeComponent } from '@libs/common-interceptor';

import { HttpService } from './shared/services/http-service.service';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
// import { NgxJsonapiModule } from 'ngx-jsonapi';
import { httpInterceptorProviders } from './shared/interceptors/index';

import { JsonapiBootstrap } from 'ngx-jsonapi';
//import { environment } from 'projects/customer/src/environments/environment';
// import { httpInterceptorProviders } from './shared/interceptors';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TranslationService } from './shared/services/translation.service';
import { environment } from 'projects/customer/src/environments/environment';

import { MixpanelService } from './shared/services/mixpanel-service.service';
import {
    MENU_ANALYTICS,
    MENU_AUTH_BRIDGE,
    MENU_COUNT_PORTS,
    MENU_DASHBOARD,
    MENU_DATA_TRANSFER,
    MENU_GETTER_SETTER,
    MENU_PERMISSIONS,
    MENU_STORAGE
} from './shared/menu/menu-facade.service';
import { IdleTimeoutModule } from '@libs/idle-timeout';
import { OrderResolverService } from './guards/order-resolver.service.ts';
import { ProblemOrderServiceService } from './guards/problem-order.service.service';
import { PermissionService } from './shared/services/permission.service';
import { ChurnZeroService } from './shared/services/churn-zero.service';
import { AuthBridgeService } from './shared/services/auth-bridge.service';
import { AddressBookService } from './layouts/private_layouts/accounts/address-book/address-book.service';
import { DataTransferService } from './shared/services/data-transfer.service';
import { GetterSetterService } from './shared/services/getter-setter.service';
import { LocalStorageService } from './shared/services/local-storage.service';
import { DashboardService } from './layouts/private_layouts/dashboard/dashboard.service';
import { ProductService } from './layouts/private_layouts/products/product.service';
import { OrderService } from './layouts/private_layouts/orders/order.service';
import { PoService } from './layouts/private_layouts/purchase-orders/po.service';
import { SuppliersService } from './layouts/private_layouts/suppliers/suppliers.service';
import { ManageReportService } from './layouts/private_layouts/manage-report/manage-report.service';
import { ProductConfigurationService } from './layouts/private_layouts/products-configuration/products-configuration.service';
import { CookieConsentModule } from '@libs/cookie-consent';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    imports: [
        BrowserModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot({
            // ToastrModule added
            closeButton: true,
            positionClass: 'toast-top-center',
            toastComponent: AncToastComponent
        }),
        NgxPermissionsModule.forRoot(),
        LoadingBarHttpClientModule,
        // Kept eager: IdleWarningModalComponent is created dynamically rather
        // than declared in app.component.html.
        IdleTimeoutModule,
        // Kept eager: app.component.html renders <app-cookie-consent-modal>.
        CookieConsentModule,
        AncViewportNoticeComponent
    ],
    providers: [
        HttpService,
        // Was provided at root only as a side effect of eagerly importing
        // CommonComponentsModule. Pinned explicitly now that it is lazy-only.
        DatePipe,
        httpInterceptorProviders,
        TranslationService,
        MixpanelService,
        OrderResolverService,
        ProblemOrderServiceService,
        PermissionService,
        { provide: MENU_PERMISSIONS, useExisting: NgxPermissionsService },
        { provide: MENU_STORAGE, useExisting: LocalStorageService },
        { provide: MENU_DATA_TRANSFER, useExisting: DataTransferService },
        { provide: MENU_ANALYTICS, useExisting: ChurnZeroService },
        { provide: MENU_AUTH_BRIDGE, useExisting: AuthBridgeService },
        { provide: MENU_GETTER_SETTER, useExisting: GetterSetterService },
        { provide: MENU_DASHBOARD, useExisting: DashboardService },
        {
            provide: MENU_COUNT_PORTS,
            useFactory: (
                productService: ProductService,
                orderService: OrderService,
                poService: PoService,
                supplierService: SuppliersService,
                reportsService: ManageReportService,
                productConfigurationService: ProductConfigurationService,
                addressBookService: AddressBookService
            ) => ({
                productService,
                orderService,
                poService,
                supplierService,
                reportsService,
                productConfigurationService,
                addressBookService
            }),
            deps: [
                ProductService,
                OrderService,
                PoService,
                SuppliersService,
                ManageReportService,
                ProductConfigurationService,
                AddressBookService
            ]
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
    public constructor() {
        JsonapiBootstrap.bootstrap({
            user_config: { url: environment.APIV1ENDPOINT }
        });
    }
}
